<li class="d-flex justify-content-between" (click)="onMenuItemClick(menuItem)">
  <span class="main-menu-list-mobile-lables f-font">
    {{ menuItem.name }}
  </span>
</li>
